import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseEntity } from "../../../base-models/base-entity";
import { BaseContainerService } from "./base-container-service";
import { ModelData } from '../../../base-models/model-data';

@Injectable({
    providedIn: 'root'
})
export class PageContainerService<T extends BaseEntity> extends BaseContainerService<T> {
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected router: Router
    ){
        super();
    }
    
    ShowList(){

    }

    ShowUpdate(){

    }

    AddItem(){
        //this.activatedRoute.url
            //.subscribe(url => {
        this.router.navigate([this.router.url + '/-1']);
        //})
    }

    EditItem(modelData: ModelData, ID: number){
        //this.activatedRoute.url
            //.subscribe(url => {
        this.router.navigate([this.router.url + '/' + ID]);
            //})
    }
}